import { all, takeEvery, takeLatest, put, fork, call } from "redux-saga/effects";

import {accountService} from "@iso/services";
import actions from "./actions";

function* getAccountsRequest() {
  yield takeEvery(actions.GET_ACCOUNTS_REQUEST, function* ({ payload }) {
    const { role, mail, searchKeyword, page, size } = payload;
    try {
      const data = yield call(accountService.fetchAccounts, {
        role,
        mail,
        searchKeyword,
        page,
        size,
      });

      yield put({
        type: actions.GET_ACCOUNTS_SUCCESS,
        accounts: data ? data.accounts : [],
        total: data ? data.total : 0,
      });
    } catch (error) {
      yield put({ type: actions.GET_ACCOUNTS_ERROR, error: error.response });
    }
  });
}

export function* getAccount() {
  yield takeLatest(actions.GET_ACCOUNT_REQUEST, function* ({ payload }) {
    const { accountId } = payload;
    try {
      const account = yield call(accountService.getAccount, { id: accountId });
      if (account.chainId) {
        yield put({
          type: actions.GET_STORES_REQUEST,
          payload: { chainIdValue: account.chainId },
        });
      }

      if(account.team !== null && account.team !== undefined) {
        account.team = account.team.split(",").map(Number);
      } else {
        account.team = [];
      }

      yield put({
        type: actions.GET_ACCOUNT_SUCCESS,
        account,
      });
    } catch (e) {
      yield put({ type: actions.GET_ACCOUNT_ERROR });
    }
  });
}

export function* getChainsData() {
  yield takeLatest(actions.GET_CHAINS_REQUEST, function* () {
    try {
      const { chains } = yield call(accountService.loadChainData);
      yield put({
        type: actions.GET_CHAINS_SUCCESS,
        chains,
      });
    } catch (e) {
      yield put({ type: actions.GET_CHAINS_ERROR });
    }
  });
}

export function* getStoresData() {
  yield takeLatest(actions.GET_STORES_REQUEST, function* ({ payload }) {
    const { chainIdValue } = payload;
    try {
      const { stores } = yield call(accountService.loadStoreData, {
        chainId: chainIdValue,
      });
      yield put({
        type: actions.GET_STORES_SUCCESS,
        stores,
      });
    } catch (e) {
      yield put({ type: actions.GET_STORES_ERROR });
    }
  });
}

export function* createAccount() {
  yield takeLatest(actions.ADD_ACCOUNT_REQUEST, function* ({ payload }) {
    const { data, resolve, reject } = payload;
    try {
      const account = yield call(accountService.createAccount, { ...data });
      yield put({
        type: actions.ADD_ACCOUNT_SUCCESS,
        account,
      });
      yield resolve();
    } catch (e) {
      yield put({ type: actions.ADD_ACCOUNT_ERROR });
      reject(e);
    }
  });
}

export function* editAccount() {
  yield takeLatest(actions.EDIT_ACCOUNT_REQUEST, function* ({ payload }) {
    const { accountId, data, resolve, reject } = payload;
    try {
      const account = yield call(accountService.editAccount, {
        accountId: +accountId,
        ...data,
      });
      if(account.team !== null && account.team !== undefined) {
        account.team = account.team.split(",").map(Number);
      } else {
        account.team = [];
      }
      yield put({
        type: actions.EDIT_ACCOUNT_SUCCESS,
        account,
      });
      yield resolve(account);
    } catch (e) {
      yield put({ type: actions.EDIT_ACCOUNT_ERROR });
      reject();
    }
  });
}

export function* deleteAccount() {
  yield takeLatest(actions.DELETE_ACCOUNT_REQUEST, function* ({ payload }) {
    const { accountId, resolve, reject } = payload;
    try {
      yield call(accountService.deleteAccount, {accountId: accountId});
      yield put({
        type: actions.DELETE_ACCOUNT_SUCCESS,});
      yield resolve();
    } catch (e) {
      yield put({ type: actions.DELETE_ACCOUNT_ERROR });
      reject();
    }
  });
}

function* getTeamAchievement() {
  yield takeEvery(actions.GET_TEAM_ACHIEVEMENT_REQUEST, function* ({ payload }) {
    const {
      listTeam,
      fromStartDate,
      toStartDate,
      resolve,
      reject,
    } = payload;
    try {
      const response = yield call(accountService.getTeamAchievement, {
        listTeam,
        fromStartDate,
        toStartDate,
        resolve,
        reject,
      });

      yield put({
        type: actions.GET_TEAM_ACHIEVEMENT_SUCCESS,
        teamAchievement: response.teamAchievementResult ?? [],
      });
      yield resolve(response);
    } catch (e) {
      yield put({
        type: actions.GET_TEAM_ACHIEVEMENT_ERROR,
        error: e.message,
      });
    }
  });
}

function* getTeamContentAchievement() {
  yield takeEvery(actions.GET_TEAM_CONTENT_ACHIEVEMENT_REQUEST, function* ({ payload }) {
    const {
      listTeam,
      fromStartDate,
      toStartDate,
      exportTypes,
      resolve,
      reject,
    } = payload;
    try {
      const response = yield call(accountService.getTeamContentAchievement, {
        listTeam,
        fromStartDate,
        toStartDate,
        exportTypes,
        resolve,
        reject,
      });
      yield put({
        type: actions.GET_TEAM_CONTENT_ACHIEVEMENT_SUCCESS,
        teamContentAchievement: response?.teamContentAchievementResult ?? []
      });
      yield resolve(response);
    } catch (e) {
      yield put({
        type: actions.GET_TEAM_CONTENT_ACHIEVEMENT_ERROR,
        error: e.message,
      });
    }
  });
}
export function* getMemberList() {
  yield takeLatest(actions.GET_MEMBER_LIST_REQUEST, function* ({ payload }) {
    const { executedTeam } = payload;
    try {
      const [memberList] = yield all([
        call(accountService.getMemberList, payload),
      ]);
      yield put({
        type: actions.GET_MEMBER_LIST_SUCCESS,
        memberList: memberList?.accounts || [],
      });
    } catch (e) {
      yield put({ type: actions.GET_MEMBER_LIST_ERROR });
    }
  });
}


export default function* rootSaga() {
  yield all([fork(getAccountsRequest)]);
  yield all([fork(getAccount)]);
  yield all([fork(getChainsData)]);
  yield all([fork(getStoresData)]);
  yield all([fork(createAccount)]);
  yield all([fork(editAccount)]);
  yield all([fork(deleteAccount)]);
  yield all([fork(getTeamAchievement)]);
  yield all([fork(getTeamContentAchievement)]);
  yield all([fork(getMemberList)]);
}
